/**
 * Converts a snake_case string to Title Case
 * @function snakeToTitleCase
 * @param {string} snakeCase
 * @return {string}
 * @example snakeToTitleCase('test_string') => 'Test String'
 * @example snakeToTitleCase('tEst_sTrInG') => 'Test String' -- Handles mixed case inputs
 * @example snakeToTitleCase('TEST') => 'Test' -- Handles all uppercase inputs
 */
const snakeToTitleCase = (str) => {
  if (!str) return '';
  return str
    .toLowerCase()
    .split('_')
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ');
};

export default snakeToTitleCase;
